import { useQuery } from "@apollo/client";

import { GET_DIFFICULTY_ENUMS } from "../pages/ActivityLibrary/queries";
import { Option } from "../types/utils";

interface DifficultyEnumsResponse {
  difficultyEnums: string[];
}

export const useDifficultyEnums = () => {
  const { data, loading, error } = useQuery<DifficultyEnumsResponse>(GET_DIFFICULTY_ENUMS, {
    fetchPolicy: "cache-and-network",
  });

  const difficultyOptions: Option<string>[] = (data?.difficultyEnums || []).map((difficulty) => ({
    value: difficulty,
    label: difficulty,
  }));

  const difficultyEnums: string[] = data?.difficultyEnums || [];

  return {
    difficultyOptions,
    difficultyEnums,
    loading,
    error,
  };
};
